import { useState, useEffect } from "react";
import { Upload } from "lucide-react";
import nopic from "../../../Images/noimage.jpg"

export default function FileUploadSection({ 
  accessToken, 
  handleSignIn, 
  handleFileUpload, 
  files, 
  supportedFormats, 
  isPremium,
  setAccessToken
}) {
  const [userProfile, setUserProfile] = useState(null);

  // Fetch user profile when accessToken is available
  useEffect(() => {
    const fetchUserProfile = async (token) => {
      if (!token) return;
      try {
        const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${token}` }
        });
        const profile = await res.json();
        setUserProfile(profile);
      } catch (err) {
        console.error("Failed to fetch user profile", err);
      }
    };
    fetchUserProfile(accessToken);
  }, [accessToken]);


  console.log("urrr",userProfile)

  return (
    <div className="mb-6">
      {/* Sign-in Section */}
      {!accessToken ? (
        <div className="flex justify-center mb-4">
          <button
            onClick={handleSignIn}
            className="bg-cyan-600 text-white px-5 py-2 rounded-lg shadow hover:bg-cyan-700 transition font-medium"
          >
            Sign in with Google
          </button>
        </div>
      ) : (
<div className="flex flex-col items-center mb-4">
  {/* Display Google User Info */}
  {userProfile && (
    <div className="flex items-center gap-3 bg-gray-100 px-4 py-2 rounded-lg shadow-sm">
      <img
        src={userProfile.picture !== "" ? userProfile.picture : nopic}
        alt={userProfile.name}
        className="w-8 h-8 rounded-full"
        referrerPolicy="no-referrer"
      />
      <div className="text-left">
        <p className="text-sm font-medium text-gray-800">{userProfile.name}</p>
        <p className="text-xs text-gray-500">{userProfile.email}</p>
      </div>
      {/* Sign Out Button */}
      <button
        onClick={() => {
          setAccessToken(null);
          setUserProfile(null);
          localStorage.removeItem("googleAccessToken");
        }}
        className="ml-4 bg-red-500 text-white text-xs px-3 py-1 rounded hover:bg-red-600 transition"
      >
        Sign Out
      </button>
    </div>
  )}
  <p className="mt-2 text-xs text-gray-400 text-center">
    You are signed in. Upload your file(s) to generate a secure QR code.
  </p>
</div>

      )}

      {/* File Upload Section */}
      <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center cursor-pointer hover:border-cyan-500 transition">
        <input
          type="file"
          id="fileInput"
          multiple
          accept={supportedFormats.map(f => "." + f).join(",")}
          onChange={handleFileUpload}
          className="hidden"
        />
        <label
          htmlFor="fileInput"
          className={`flex flex-col items-center space-y-2 cursor-pointer ${
            !accessToken ? "opacity-50 pointer-events-none" : ""
          }`}
        >
          <Upload className="h-10 w-10 text-cyan-600" />
          <span className="text-gray-600">
            {files.length ? `${files.length} file(s) selected` : "Click to upload file(s)"}
          </span>
          <span className="text-xs text-gray-400">
            Supported formats: {supportedFormats.join(", ")}
          </span>
          {!isPremium && files.length > 1 && (
            <span className="text-xs text-red-500 mt-1">
              Batch upload is a Premium feature
            </span>
          )}
        </label>
      </div>
    </div>
  );
}
